import gridContainer, { featureGridStyles } from './grid-container';
import heading, { headingStyles } from './heading';

const featureGrid = {
  heading,
  gridContainer
};

export type GridVariantsType = 'default' | 'masonry' | 'offset' | 'cards';
export type HeadingVariantsType = 'default' | 'leftAlign' | 'darkBackground';

const gridVariants = Object.keys(featureGridStyles) as GridVariantsType[];
const headingVariants = Object.keys(headingStyles) as HeadingVariantsType[];

export const featureGridVariants = {
  heading: headingVariants,
  gridContainer: gridVariants
};

export interface FeatureGridType {
  /** The main grid container in the Feature Grid Component */
  Grid: GridVariantsType;
  /** Section above grid container, consisting of heading and subheading */
  Heading: HeadingVariantsType | HeadingVariantsType[];
}

export default featureGrid;
